module.exports = __webpack_public_path__ + "static/media/MacLean2012.c5fc4251.pdf";